import { render, staticRenderFns } from "./InvCreateDialogFormCard.vue?vue&type=template&id=c3407a24&"
import script from "./InvCreateDialogFormCard.vue?vue&type=script&lang=ts&"
export * from "./InvCreateDialogFormCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports